import { render } from "./BadgeMappingTab.vue?vue&type=template&id=1ab1a07c&scoped=true"
import script from "./BadgeMappingTab.vue?vue&type=script&lang=js"
export * from "./BadgeMappingTab.vue?vue&type=script&lang=js"

import "./BadgeMappingTab.vue?vue&type=style&index=0&id=1ab1a07c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab1a07c"]])

export default __exports__